module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmh"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("Believing in yourself can get you only so far. It’s others believing in you that truly makes the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "spb"
  }, [_vm._v("Ours:")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Imma—For first giving us life and then for teaching us how to embrace it.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Abba—For teaching us to question everything.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Howard Deutsch—For the unenviable job of filtering us and, by extension, ensuring we live to write another day.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("David G. Hartwell—For your stewardship, patience, and insight … and patience.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Stacy Hague-Hill—For the skill with which you’ve kept us on track, not to mention the unforgettable adventures in dining.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Patty Garcia—For working so hard on getting us out there.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Amber Hopkins—For helping to keep us there.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Edwin Rivera—For giving us a chance.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Robert Sawyer—For all the advice, insight, and support.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Alec Schram—For ensuring that our science is sound, and saving Ceres from near-certain catastrophe (nano-carbon Bucky scaffolding?—you genius, you!).")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Richard Mueller of "), _c('a', {
    attrs: {
      "href": "http://3232design.com",
      "target": "_blank"
    }
  }, [_vm._v("3232design.com")]), _vm._v("—For allowing us to use a majority of his talent for a minority share of our future earnings.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Larry Carlin—For making this book better.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Facebook, LiveJournal, and Twitter readers—For keeping us going through the ups and downs, wild road trips, and never-ending search for the next NBG!")]), _vm._v(" "), _c('p', {
    staticClass: "spb"
  }, [_vm._v("Dani’s:")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Deborah—For eighteen years of holding hands, sharing dreams, and being my song of songs.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Eliana, Yonatan, and Gavriel—For always keeping me on my toes.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Carrie Bleiweiss—For ultimate dooberatiousness, apricot leaves, and so many wonderfully lost hours.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Insomniyakkers, Wolverines, and the Magnificent Seven—For helping me to set the bar on words and ideas hopefully equal to your intelligence, wit, and curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "spb"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("Eytan’s:")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Doctor Miles Morgan—An ardent believer in socialism, he taught me what it means to be a true gentleman by giving me the books of Rand, Hayek, and Friedman. “If you’re going to be a capitalist, you may as well be an informed capitalist.” You did not have to give me the tools to defend my beliefs. You chose to, (freely).")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Dalia Taft—For the gift of reading, which no other person in the world seemed to be able to teach me, and for having the patience to deal with a younger brother who has all the grace, social skill, and subtlety of a gorilla falling from orbit.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b26fed4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Unincorporated_ackn-1.vue
// module id = 78
// module chunks = 0